import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(['work']),
        getByWork: (state) => work => {
            return state.objs.find(license => license.work == work);
        }
    },
    mutations: {
        ...functions.createDefaultMutations(['work'])
    },
    actions: {
        ...functions.createDefaultActionsWithStore(['work'])
    },
}